// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__jXo5G","spinner":"Loader_spinner__Msh5z","spin":"Loader_spin__z+6X1"};